var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "div",
        { staticClass: "top-wrapper" },
        [
          _c("img", {
            staticClass: "top-img",
            attrs: { src: require("@/static/img/home/banner-1.png") }
          }),
          _vm._v(" "),
          _c("search-input", {
            on: { "search-by-keyword": _vm.searchByKeyword }
          }),
          _vm._v(" "),
          _vm.level === 1 ? _c("statistics-list") : _vm._e(),
          _vm._v(" "),
          _c("img", {
            staticClass: "cloud-bg",
            attrs: { src: require("@/static/img/home/home-cloud.png") }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "home-bottom-bg",
            attrs: { src: require("@/static/img/home/home-bottom-bg.png") }
          }),
          _vm._v(" "),
          _c("type-list")
        ],
        1
      ),
      _vm._v(" "),
      _vm.level !== 3 ? _c("hot-search") : _vm._e(),
      _vm._v(" "),
      _vm.level !== 3
        ? _c("hot-radar", { on: { "search-by-keyword": _vm.searchByKeyword } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "flex",
        {
          staticClass: "footer",
          attrs: { justify: "between", align: "center" }
        },
        [
          _c("img", { attrs: { src: require("@/static/img/home/16.png") } }),
          _vm._v(" "),
          _c("div", { staticClass: "footer-text" }, [
            _c("p", [_vm._v("主办：中共贵州省委宣传部")]),
            _vm._v(" "),
            _c("p", [_vm._v("承办：多彩贵州网有限责任公司")]),
            _vm._v(" "),
            _c("p", [_vm._v("黔ICP备15002649号-4")])
          ]),
          _vm._v(" "),
          _c("img", { attrs: { src: require("@/static/img/home/17.png") } })
        ]
      ),
      _vm._v(" "),
      _c("back-top")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }